import { useLanguage } from '../i18n/LanguageContext';

const FLAGS = { fr: '🇫🇷', en: '🇬🇧', es: '🇪🇸', pt: '🇧🇷' };
const LABELS = { fr: 'FR', en: 'EN', es: 'ES', pt: 'PT' };

const LanguageSelector = ({ style }) => {
  const { lang, setLang, SUPPORTED_LANGS } = useLanguage();

  return (
    <div data-testid="language-selector" style={{ display: 'inline-flex', gap: 4, ...style }}>
      {SUPPORTED_LANGS.map(l => (
        <button
          key={l}
          data-testid={`lang-btn-${l}`}
          onClick={() => setLang(l)}
          style={{
            padding: '4px 10px', borderRadius: 6, cursor: 'pointer',
            fontFamily: "'Georgia', serif", fontSize: 12, fontWeight: 600,
            border: lang === l ? '1px solid #D4AF37' : '1px solid rgba(212,175,55,0.15)',
            backgroundColor: lang === l ? 'rgba(212,175,55,0.12)' : 'transparent',
            color: lang === l ? '#D4AF37' : '#D4AF37',
            transition: 'all 0.2s',
          }}
        >
          {FLAGS[l]} {LABELS[l]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
